import myapps from './myapps'

export default [
  ...myapps,
]
